import { SelectField } from '@/components';
import { useCostOptions } from '@/features/master-table/hooks';
import { useProjectFormContext } from '@/features/project/_hooks/form-context';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  fiscalYear: string | undefined;
};

export const MainCostField: FC<Props> = ({ fiscalYear }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useProjectFormContext();

  const costOptions = useCostOptions({
    referenceFiscalYear: fiscalYear,
  });

  return (
    <SelectField
      name="data.mainCostIds"
      label={t('main-cost')}
      hint={t('hint-main-cost')}
      mode="multiple"
      control={control}
      errors={errors}
      options={costOptions.data}
      loading={costOptions.isPending}
      useNotInOption
      required
    />
  );
};
